document.addEventListener("DOMContentLoaded", () => {
  const basePath = "/assets/favicon";

  const checkFaviconExists = (path) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = path;
    });
  };

  // Alleen de tab-favicon (32x32) heeft een dark/light-variant. Apple-touch-icon
  // en manifest blijven op de base-map (die worden door de template gezet en
  // hebben geen themavariant nodig).
  const setFavicon = async () => {
    const isDarkMode = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;
    const folder = isDarkMode ? "light" : "dark";
    const variantPath = `${basePath}/${folder}`;

    const hasVariant = await checkFaviconExists(
      `${variantPath}/favicon-32x32.png`,
    );
    const path = hasVariant ? variantPath : basePath;

    const favicon32 = document.querySelector('link[rel="icon"][sizes="32x32"]');
    if (favicon32) favicon32.href = `${path}/favicon-32x32.png`;
  };

  setFavicon();

  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", setFavicon);
});
